
import apiClient from "../../utils/apiclient";
export const teamdata = async (
  token: string,
  team: number[],
  module: number[],
  search: string,
  page: number,
  limit: number,
    role: string,  
  start_date: string,
  end_date: string
  
) => {
  return await apiClient.post(
    '/admin/team-member/getall',
    {
      team,
      module,
      search,
      page,
      limit,
      role, 
      start_date,
   
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

  